export default "__VITE_ASSET__CGnU_QPf__"